import { useRef, useCallback } from 'react';
import useSSRLayoutEffect from '../useSSRLayoutEffect/3f7dfe597927d283cea086f49f27f37e393114860baab130a0642ce629c0aa18.cfe-internal.js';

/**
 * An abstraction on top of `useCallback` that does not trigger a re-render when the function parameter changes.
 * @param fn - The function to memoize.
 * @returns A memoized version of the function that never changes.
 * @see https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */
function useEventCallback(fn) {
  var fnRef = useRef(fn);
  useSSRLayoutEffect(function () {
    fnRef.current = fn;
  });
  return useCallback(function (event) {
    return (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore: Left side of comma operator is unused and has no side effects. See https://stackoverflow.com/questions/11541134/javascript-syntax-0-fnargs
      (0, fnRef.current)(event)
    );
  }, []);
}

export { useEventCallback as default };
